import { motion } from 'framer-motion';

export const SubsidyHighlights = ({ scheme }) => (
  <section className="py-12 bg-white border-b border-slate-100">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
        {scheme.highlights.map((highlight, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: index * 0.1 }}
            className="text-center p-6 rounded-xl bg-[#f8fafc]"
          >
            <div className={`w-12 h-12 mx-auto mb-3 rounded-xl bg-gradient-to-br ${scheme.color} flex items-center justify-center text-white`}>
              {highlight.icon}
            </div>
            <p className="text-2xl font-semibold text-[#0f172a] mb-1">{highlight.value}</p>
            <p className="text-sm text-[#64748b]">{highlight.title}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
